import type { SelectHTMLAttributes } from 'react';
import { cn } from '../../utils/cn';

type Props = SelectHTMLAttributes<HTMLSelectElement>;

/** Native select styled for the DevTools shell. */
export function Select({ className, children, ...rest }: Props) {
  return (
    <select
      className={cn(
        'w-full rounded-xl border border-[var(--border)] bg-[var(--background)] px-3 py-2 text-sm text-[var(--foreground)] focus:outline-none focus:ring-2 focus:ring-[var(--ring)] disabled:opacity-40',
        className,
      )}
      {...rest}
    >
      {children}
    </select>
  );
}
